import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";

class CartaProducto extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			activeRotate1: "",
			activeRotate2: "",
		};
	}
	componentWillMount() {}
	componentDidMount() {
		const { classes } = this.props;
		// console.log("carta producto", this.props.Producto )
	}

	// Función para determinar si ImagenProducto es una URL o base64
	getImageSrc = (imagenProducto) => {
		if (!imagenProducto) {
			return "https://placehold.co/150x200";
		}

		// Verificar si es una URL (http:// o https://)
		if (
			typeof imagenProducto === "string" &&
			(imagenProducto.startsWith("http://") ||
				imagenProducto.startsWith("https://"))
		) {
			return imagenProducto;
		}

		// Si no es URL, asumir que es base64
		return "data:image/png;base64," + imagenProducto;
	};
	render() {
		const { classes, ...rest } = this.props;
		return (
			<div>
				<Card>
					<CardHeader color="primary">
						<center>{this.props.Producto.NombreProducto}</center>
					</CardHeader>
					<CardBody>
						<center>
							<img
								style={{
									width: "250px",
									height: "250px",
									objectFit: "cover",
									objectPosition: "center center",
								}}
								src={this.getImageSrc(this.props.Producto.ImagenProducto)}
								alt="Product image"
							/>
						</center>
					</CardBody>
				</Card>
			</div>
		);
	}
}

export default withStyles(styles)(CartaProducto);
